import {
  getSystemSettings,
  saveSystemSettings,
  SystemSettings,
  DEFAULT_TOURNAMENT_COURT_RENTAL_COMMISSION_RATE,
} from "../../utils/commissionConfig";
import { FinancialConfig } from "../../types/financial";
import { DEFAULT_FINANCIAL_CONFIG } from "./FinancialCalculator";

export function getFinancialConfig(): FinancialConfig {
  const settings = getSystemSettings();
  
  // Normaliza payer de whoPaysMpFee se necessário
  let payer = settings.gatewayFeePayer;
  if (!payer && settings.whoPaysMpFee) {
    payer = settings.whoPaysMpFee === "arena" ? "ARENA" : "PLATFORM";
  }

  // Normaliza gateway de preferredGateway se necessário
  let gateway = settings.activeGateway;
  if (!gateway && settings.preferredGateway) {
    gateway = settings.preferredGateway.toUpperCase() === "MERCADOPAGO" ? "MERCADO_PAGO" : "ASAAS";
  }

  return {
    platformCommissionRate: settings.platformCommissionRate ?? DEFAULT_FINANCIAL_CONFIG.platformCommissionRate,
    gatewayFeeModel: settings.gatewayFeeModel ?? DEFAULT_FINANCIAL_CONFIG.gatewayFeeModel,
    gatewayFeeFixed: settings.gatewayFeeFixed ?? DEFAULT_FINANCIAL_CONFIG.gatewayFeeFixed,
    gatewayFeePercentage: settings.gatewayFeePercentage ?? DEFAULT_FINANCIAL_CONFIG.gatewayFeePercentage,
    gatewayFeePayer: payer ?? DEFAULT_FINANCIAL_CONFIG.gatewayFeePayer,
    activeGateway: gateway ?? DEFAULT_FINANCIAL_CONFIG.activeGateway,
    pixAutoEnabled: settings.pixAutoEnabled ?? true,
    allowManualPaymentConfirmInTest: settings.allowManualPaymentConfirmInTest ?? true,
    tournamentCourtRentalCommissionRate:
      settings.tournamentCourtRentalCommissionRate ?? DEFAULT_TOURNAMENT_COURT_RENTAL_COMMISSION_RATE,
    tournamentCourtRentalCommissionMode: settings.tournamentCourtRentalCommissionMode ?? "ADD",
  };
}

export function saveFinancialConfig(newConfig: Partial<FinancialConfig>): SystemSettings {
  const current = getFinancialConfig();
  const updatedConfig = { ...current, ...newConfig };

  const systemUpdate: Partial<SystemSettings> = {
    platformCommissionRate: updatedConfig.platformCommissionRate,
    courtCommissionRate: updatedConfig.platformCommissionRate,
    gatewayFeeModel: updatedConfig.gatewayFeeModel,
    gatewayFeeFixed: updatedConfig.gatewayFeeFixed,
    gatewayFeePercentage: updatedConfig.gatewayFeePercentage,
    gatewayFeePayer: updatedConfig.gatewayFeePayer,
    whoPaysMpFee: updatedConfig.gatewayFeePayer === "ARENA" ? "arena" : "platform",
    activeGateway: updatedConfig.activeGateway,
    preferredGateway: updatedConfig.activeGateway === "MERCADO_PAGO" ? "mercadopago" : "asaas",
    pixAutoEnabled: updatedConfig.pixAutoEnabled,
    allowManualPaymentConfirmInTest: updatedConfig.allowManualPaymentConfirmInTest,
    tournamentCourtRentalCommissionRate: updatedConfig.tournamentCourtRentalCommissionRate,
    tournamentCourtRentalCommissionMode: updatedConfig.tournamentCourtRentalCommissionMode,
  };

  return saveSystemSettings(systemUpdate);
}
